export type Procedure = {
  name: string
  category: string
  description: string
  duration: string
  image: string
  featured?: boolean
}

export const procedures: Procedure[] = [
  {
    name: 'Breast Augmentation',
    category: 'Breast',
    description:
      'Implant and fat-transfer augmentation planned around your frame, tissue quality and desired projection — with sizing done in-office, not guessed at.',
    duration: '1–2 hrs · Outpatient',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/466fd02a-5750-4d2e-bf4f-ed22fb793966.jpg',
    featured: true,
  },
  {
    name: 'Tummy Tuck',
    category: 'Body',
    description:
      'Abdominoplasty that restores the abdominal wall after pregnancy or weight loss.',
    duration: '2–4 hrs',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/398b8ecb-e912-4d7d-a74a-64490a169d7b.jpg',
  },
  {
    name: 'Facelift',
    category: 'Face',
    description:
      'Deep-plane lifting for a rested, unmistakably natural jawline and neck.',
    duration: '3–5 hrs',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/d2d5adb7-5a5b-4f70-8d84-33a30ee26dd3.jpg',
  },
  {
    name: 'Brazilian Butt Lift',
    category: 'Body',
    description:
      'Ultrasound-guided fat transfer for safe, proportionate contour and volume.',
    duration: '2–3 hrs',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/b18690aa-cd92-4e6c-b884-388cf468cc79.jpg',
  },
  {
    name: 'Rhinoplasty',
    category: 'Face',
    description:
      'Structural and preservation rhinoplasty balanced to the rest of your face.',
    duration: '2–3 hrs',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/6c16eedc-59dd-4979-b5e8-c6a54fc091c7.jpg',
  },
]

export type MedSpaTreatment = {
  name: string
  description: string
  detail: string
  image: string
}

export const medSpaTreatments: MedSpaTreatment[] = [
  {
    name: 'Botox & Dysport',
    description:
      'Conservative neuromodulator placement that softens lines while keeping your expression fully your own.',
    detail: '15 min · Results in 3–7 days',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/6da5a84e-ad04-492c-8198-ef13a8aa3bb6.jpg',
  },
  {
    name: 'Lip Fillers',
    description:
      'Hyaluronic acid artistry focused on shape and hydration before volume — never overfilled.',
    detail: '30 min · Lasts 9–12 months',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/cfe60d90-606f-46fd-aede-c8b0706440b1.jpg',
  },
  {
    name: 'Laser Hair Removal',
    description:
      'Medical-grade laser calibrated for every Miami skin tone, with comfort settings adjusted per session.',
    detail: '6–8 sessions · All skin types',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/656f179d-8e9c-4858-9663-9165d3eadaf8.jpg',
  },
]
